import styled from 'styled-components'

export const SwitcherButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  width: 100%;
  padding: 0 16px;
  height: 100%;

  @media (max-width: 960px) {
    padding: 0;
  }
`

export const ClinicName = styled.span`
  flex: 1;
  text-align: left;
  font-size: 18px;
  font-weight: 500;
  color: #111111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 5px;
  font-family: NeueHaasDisplay, sans-serif;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  height: 32px;

  @media (max-width: 960px) {
    flex: none;
    font-size: 15px;
    margin-top: 0;
    height: 28px;
  }
`

export const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;

  @media (max-width: 960px) {
    margin-top: 0;
  }
`

export const LogoBox = styled.div`
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 6px;
  background-color: #111111;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  font-family: NeueHaasDisplay, sans-serif;
  text-transform: uppercase;

  @media (max-width: 960px) {
    width: 28px;
    height: 28px;
    min-width: 28px;
    font-size: 14px;
  }
`
